export const RegMap = {
    Artifact: /<Artifact\s+([^>]*?)(?:>|$)\n?([\s\S]*?)\n?(?:<\/Artifact>|$)/g,
    ProjectFile: /<projectFile filePath="([\s\S]*?)"[\s\S]*?>([\s\S]*?)(?:\n<\/projectFile>|$)/g,
    ApiJson: /<ApiJson(?:\s+([^>]*))?(?:>([\s\S]*?)(?:<\/ApiJson>|$))?/g,
    ApiDocMarkdown: /<ApiDocMarkdown(?:\s+([^>]*))?(?:>([\s\S]*?)(?:<\/ApiDocMarkdown>|$))?/g,
};
